import type { ContentNode } from "./contentNode";

const STORAGE_PREFIX = "readable-content:";

export interface StoredReadableContent {
  title: string;
  content: ContentNode;
}

/** Persist readable payloads for utility-window handoff (keyed by id). */
export function putReadableContent(payload: StoredReadableContent): string {
  const contentId = crypto.randomUUID();
  sessionStorage.setItem(
    `${STORAGE_PREFIX}${contentId}`,
    JSON.stringify(payload)
  );
  return contentId;
}

export function getReadableContent(contentId: string): StoredReadableContent | null {
  const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${contentId}`);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredReadableContent;
  } catch {
    return null;
  }
}

export function removeReadableContent(contentId: string): void {
  sessionStorage.removeItem(`${STORAGE_PREFIX}${contentId}`);
}
